<template>
    <div class="col-12 mt-3 mb-md-3">
        <router-link :to="{ name: 'item-details', params: { itemTitle: item.title, itemId: item._id } }" :title="`${item.title} - aNewItem.com`">
            <div class="card h-100 pr-2">
                <div class="row">

                    <!-- import item photo here -->
                    <div class="col-4">
                        <app-item-photo class="anewitem-img-box rounded mr-n3 h-100" :itemPhotos="item.photos"></app-item-photo>
                    </div>

                    <!-- display item details -->
                    <div class="col-8">
                        <div class="row">
                            <div class="col-12">
                                <!-- item notes here -->
                                <p class="anewitem-cart-title mb-2">{{item.title}}</p>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-sm-6 col-12 anewitem-cart-details">
                                        <p class="mb-1 pb-sm-2"><i class="fas fa-layer-group text-dark-green fa-sm"></i> {{item.category | capitalize}}</p>
                                        <p class="mb-1 pb-sm-2"><i class="fas fa-balance-scale text-dark-green fa-sm"></i> {{item.condition | capitalize}}</p>
                                        <p class="mb-0"><i class="fas fa-shipping-fast text-dark-green fa-sm"></i> Shipping Available</p>
                                    </div>
                                    <div class="col-sm-6 col-12">
                                        <!-- import item price here -->
                                        <p class="anewitem-cart-price text-sm-center"><app-item-price :item="item" :itemQty="qtyBox"></app-item-price></p>
                                        <!-- quantity adjustment here -->
                                        <div class="input-group input-group-sm mt-n3">
                                            <!-- <div @click.prevent="qtyBox > 1 ? qtyBox-- : qtyBox = 1" class="input-group-prepend clickable"> -->
                                            <div @click.prevent="decreaseQtyFxn" class="input-group-prepend clickable">
                                                <span class="input-group-text bg-light text-dark-green"><i class="fas fa-minus"></i></span>
                                            </div>
                                            <input v-model="qtyBox" type="text" class="form-control no-lines bg-white text-center">
                                            <div @click.prevent="increaseQtyFxn" class="input-group-append clickable">
                                                <span class="input-group-text bg-light text-dark-green"><i class="fas fa-plus"></i></span>
                                            </div>
                                        </div>
                                        <!-- import items action btns -->
                                        <app-item-action-btns :item="item" :pageName="thePageName"></app-item-action-btns>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import ItemPhoto from '@/components/general/shared/ItemParts/ItemPhoto.vue'
import ItemPrice from '@/components/general/shared/ItemParts/ItemPrice.vue'
import ItemActionBtns from '@/components/general/pages/itemDetailsParts/ItemActionBtns.vue'

export default {
    name: "CartItem",
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            qtyBox: 1
        }
    },
    methods: {
        theUpdateObjFxn(theQtyBox) {
            if(!theQtyBox) return
            let theUpdateObj = {
                itemId: this.item._id,
                itemQty: theQtyBox,
                itemPrice: this.item.onSale ? this.item.onSalePrice : this.item.price,
            }
            theUpdateObj.itemSumPrice = parseInt(theUpdateObj.itemQty * theUpdateObj.itemPrice)
            return theUpdateObj
        },
        increaseQtyFxn() {
            this.qtyBox++
            // update the cart item qty in local-storage as well using emit fxn
            let theUpdateObj = this.theUpdateObjFxn(this.qtyBox)
            return this.$emit('emitUpdateItemQtyFxn', theUpdateObj)
        },
        decreaseQtyFxn() {
            if(this.qtyBox < 2) {
                return this.qtyBox = 1
            }
            this.qtyBox--
            // update the cart item qty in local-storage as well using emit fxn
            let theUpdateObj = this.theUpdateObjFxn(this.qtyBox)
            return this.$emit('emitUpdateItemQtyFxn', theUpdateObj)
        },
        obtainCartItemQty() {
            // check if user already have a add-to-cart items storage on local-storage
            let localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
            if(localStorageATCItemIds && localStorageATCItemIds.length) {
                // fetch the users preffered quantity for the item
                let cartItemDetails = localStorageATCItemIds.find(cartItem => cartItem.itemId === this.item._id)
                if(cartItemDetails){
                    this.qtyBox = parseInt(cartItemDetails.itemQty)
                } 
            }
        }
    },
    computed: {
        thePageName() {
            return 'CartItem'
        }
    },
    components: {
        appItemPhoto: ItemPhoto,
        appItemPrice: ItemPrice,
        appItemActionBtns: ItemActionBtns
    },
    created() {
        this.obtainCartItemQty()
    }
}
</script>
